import React from 'react';
import UserForm from "../users/UserForm";
import RoleSelect from "../users/RoleSelect";
import {useGetRolesQuery, useGetPublisherRolesQuery} from "../../api/roleApiSlice";

export const PublisherUserForm = ({publisherId, canSelectRole, ...props}) => {
  const {data: roles = [], isSuccess} = publisherId ? useGetPublisherRolesQuery(publisherId) : useGetRolesQuery()

  return <UserForm  {...props}>
    {canSelectRole && <RoleSelect role companyType={"publisher"} roles={roles}/>}
  </UserForm>
}
